import { lazy } from 'react';
import Template from '../../../core/templates/baseApp';

const CommunityPage = lazy(() => import('../pages'));
const CallbackDiscordPage = lazy(() => import('../pages/callbackDiscord'));
export const CommunitRoutes = [
  {
    path: '',
    element: (
      <Template>
        <CommunityPage />
      </Template>
    ),
  },
  {
    path: 'callback-discord',
    element: (
      <Template>
        <CallbackDiscordPage />
      </Template>
    ),
  }
];
